module.exports = __webpack_public_path__ + "static/img/home_pc_center.c9a66ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/latast_pc/home_pc_center.png
// module id = A/36
// module chunks = 98